import {Component, EventEmitter, Input, NgZone, OnInit, Output} from "@angular/core";
import {NotificationService} from "../../notification/notification.service";
import {IconButtonType} from "../../buttons/icon-button/icon-button";
import GeocoderStatus = google.maps.GeocoderStatus;
import AutocompletePrediction = google.maps.places.AutocompletePrediction;
import PlacesServiceStatus = google.maps.places.PlacesServiceStatus;
import GeocoderResult = google.maps.GeocoderResult;

export class LocationSearchCoordinates {
    constructor(public location: string,
                public lat: number,
                public lng: number,
                public stateOnly: string,
                public countryOnly: string) {
    }
}

/**
 * Autocomplete component to search for a location using Google API
 */
@Component({
    selector: "woa-location-search-panel",
    templateUrl: "./location-search-panel.component.html"
})
export class LocationSearchPanelComponent implements OnInit {
    @Input() accuracy: number;
    @Input() latitude: number;
    @Input() longitude: number;

    @Output() onSelect: EventEmitter<LocationSearchCoordinates> = new EventEmitter();

    IconButtonType = IconButtonType;

    predictions: AutocompletePrediction[] = []; // List of predictions
    selectionHidden: boolean = false;

    private _searchText: string = "";
    private hasLocationSelection: boolean; // flag to tell if there is a current selection
    private autocompleteService = new google.maps.places.AutocompleteService(); // Google service to return search for places
    private geocoder = new google.maps.Geocoder(); // Google service to get the geolocation of a place
    private bounds; // Current location to bias the auto complete

    constructor(private zone: NgZone,
                private notificationService: NotificationService) {
    }

    ngOnInit(): void {
        let self = this;

        if (this.latitude && this.longitude) {
            const geolocation = {
                lat: this.latitude,
                lng: this.longitude
            };
            const circle = new google.maps.Circle({
                center: geolocation,
                radius: this.accuracy
            });
            self.bounds = circle.getBounds();
        }
    }

    get searchText(): string {
        return this._searchText;
    }

    set searchText(searchText: string) {
        this._searchText = searchText;

        this.predictions = [];
        this.selectionHidden = false;

        if (this._searchText) {
            // noinspection JSUnusedLocalSymbols
            this.autocompleteService.getPlacePredictions({
                input: this._searchText,
                bounds: this.bounds,
                componentRestrictions: {country: "AU"}
            }, (predictions: AutocompletePrediction[], status: PlacesServiceStatus) => this.zone.run(() => {
                this.predictions = predictions ? predictions : [];
            }));
        } else if (this.hasLocationSelection) {
            this.onSelect.next(undefined);
            this.hasLocationSelection = false;
        }
    }

    hideSelection(event: MouseEvent): void {
        event.stopPropagation();
        this.selectionHidden = true;
    }

    async selectLocation(prediction: AutocompletePrediction): Promise<void> {
        this._searchText = prediction.description;
        this.predictions = [];
        this.selectionHidden = false;

        if (prediction.types[0] === "country") {
            this.hasLocationSelection = true;
            this.onSelect.next(new LocationSearchCoordinates(this._searchText, null, null, null, prediction.terms[0].value));
        } else if (prediction.types[0] === "administrative_area_level_1") {
            this.hasLocationSelection = true;
            this.onSelect.next(new LocationSearchCoordinates(this._searchText, null, null, prediction.terms[0].value, null));
        } else {
            this.geocoder.geocode({
                placeId: prediction.place_id
            }, (responses: GeocoderResult[], status: GeocoderStatus) => {
                if (status === GeocoderStatus.OK) {
                    const lat = responses[0].geometry.location.lat();
                    const lng = responses[0].geometry.location.lng();

                    this.zone.run(() => {
                        this.hasLocationSelection = true;
                        this.onSelect.next(new LocationSearchCoordinates(this._searchText, lat, lng, null, null));
                    });
                } else {
                    console.log(status.toString());
                    return this.notificationService.displayAlert("woa.heading.address.invalidAddress", "woa.message.address.invalidAddress");
                }
            });
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/ordering-context/location-search-panel/location-search-panel.component.ts